export default "__VITE_ASSET__RngCmzlX__"